const LoadingAnimation = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    preserveAspectRatio="xMidYMid"
    style={{
      shapeRendering: "auto",
      display: "block",
      background: "rgba(255, 255, 255, 0)",
      width: "100%",
      height: "100%",
    }}
  >
    <g>
      <circle fill="#c7c7c7" r="10" cy="50" cx="84">
        <animate
          begin="0s"
          keySplines="0 0.5 0.5 1"
          values="10;0"
          keyTimes="0;1"
          calcMode="spline"
          dur="0.25s"
          repeatCount="indefinite"
          attributeName="r"
        />
        <animate
          begin="0s"
          values="#c7c7c7;#efffcb;#ffffff;#f0f0f0;#c7c7c7"
          keyTimes="0;0.25;0.5;0.75;1"
          calcMode="discrete"
          dur="1s"
          repeatCount="indefinite"
          attributeName="fill"
        />
      </circle>
      <circle fill="#c7c7c7" r="10" cy="50" cx="16">
        <animate
          begin="0s"
          keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
          values="0;0;10;10;10"
          keyTimes="0;0.25;0.5;0.75;1"
          calcMode="spline"
          dur="1s"
          repeatCount="indefinite"
          attributeName="r"
        />
        <animate
          begin="0s"
          keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
          values="16;16;16;50;84"
          keyTimes="0;0.25;0.5;0.75;1"
          calcMode="spline"
          dur="1s"
          repeatCount="indefinite"
          attributeName="cx"
        />
      </circle>
      <circle fill="#f0f0f0" r="10" cy="50" cx="50">
        <animate
          begin="-0.25s"
          keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
          values="0;0;10;10;10"
          keyTimes="0;0.25;0.5;0.75;1"
          calcMode="spline"
          dur="1s"
          repeatCount="indefinite"
          attributeName="r"
        />
        <animate
          begin="-0.25s"
          keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
          values="16;16;16;50;84"
          keyTimes="0;0.25;0.5;0.75;1"
          calcMode="spline"
          dur="1s"
          repeatCount="indefinite"
          attributeName="cx"
        />
      </circle>
      <circle fill="#ffffff" r="10" cy="50" cx="84">
        <animate
          begin="-0.5s"
          keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
          values="0;0;10;10;10"
          keyTimes="0;0.25;0.5;0.75;1"
          calcMode="spline"
          dur="1s"
          repeatCount="indefinite"
          attributeName="r"
        />
        <animate
          begin="-0.5s"
          keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
          values="16;16;16;50;84"
          keyTimes="0;0.25;0.5;0.75;1"
          calcMode="spline"
          dur="1s"
          repeatCount="indefinite"
          attributeName="cx"
        />
      </circle>
      <circle fill="#efffcb" r="10" cy="50" cx="16">
        <animate
          begin="-0.75s"
          keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
          values="0;0;10;10;10"
          keyTimes="0;0.25;0.5;0.75;1"
          calcMode="spline"
          dur="1s"
          repeatCount="indefinite"
          attributeName="r"
        />
        <animate
          begin="-0.75s"
          keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
          values="16;16;16;50;84"
          keyTimes="0;0.25;0.5;0.75;1"
          calcMode="spline"
          dur="1s"
          repeatCount="indefinite"
          attributeName="cx"
        />
      </circle>
    </g>
  </svg>
);

export default LoadingAnimation;
